<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mt-5">
        <ul class="heading-ul mb-5">
          <li>
            <router-link :to="{ path: '/makerchecker' }" class="vx-row">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              <h4>{{ $t("admin.label.ViewApproval") }}</h4>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full">
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <!-- <vs-button
                        color="primary"
                        icon-pack="feather"
                        icon="icon-edit-2"
                        class="truncate"
                        @click="editData()"
                        size="small"
                        >{{ $t("setup.label.Edit") }}</vs-button
                      > -->
                    <vs-button
                      icon-pack="feather"
                      icon="icon-eye"
                      class="truncate"
                      size="small"
                      @click.stop="goToReview"
                      >{{ $t("Review") }}</vs-button
                    >
                    <vs-button
                      icon-pack="feather"
                      icon="icon-check"
                      class="truncate"
                      size="small"
                      @click.stop="approvePopup = true"
                      >{{ $t("admin.label.Approve") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click.stop="rejectPopup = true"
                      >{{ $t("admin.label.Reject") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="block overflow-x-auto">
            <table
              v-if="ApprovalData"
              class="table w-full table-bordered table-striped"
            >
              <tr>
                <td>
                  <b>{{ $t("admin.label.ActionName") }}</b>
                </td>
                <td>{{ ApprovalData.actionName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("admin.label.EntityName") }}</b>
                </td>
                <td>{{ ApprovalData.entityName }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("admin.label.Maker") }}</b>
                </td>
                <td>{{ ApprovalData.maker }}</td>
              </tr>
              <tr>
                <td>
                  <b>{{ $t("admin.label.CreatedOn") }}</b>
                </td>
                <td>{{ ApprovalData.madeOnDate }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <b>{{ $t("admin.label.Commands") }}</b>
                  <table class="table w-full table-bordered mt-2">
                    <tr v-for="(value, key) in parsedCommandAsJson" :key="key">
                      <td>
                        <b>{{ key }}</b>
                      </td>
                      <td>{{ value }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Approve')"
        :active.sync="approvePopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 center">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">{{$t("system.label.areYouSure")}}</div>
            </div>
          </div>
          <div class="vx-row text-center">
            <div class="vx-col sm:w-full w-full" style="padding-right: 8%">
              <vs-button
                class="mr-2"
                type="border"
                @click="approvePopup = false"
              >
                {{ $t("admin.label.Cancel") }}
              </vs-button>

              <vs-button @click="approvalRequest('approve')" color="warning">
                {{ $t("admin.label.Ok") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('admin.label.Reject')"
        :active.sync="rejectPopup"
        class="popup-close mid-popup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6 center">
            <div class="vx-col sm:w-full w-full">
              <vs-input
                :label="$t('admin.label.Comment')"
                type="text"
                class="w-full font-semibold mb-2 starlabel"
                v-model="rejectComment"
              />
            </div>
          </div>
          <div class="vx-row text-center">
            <div class="vx-col sm:w-full w-full" style="padding-right: 8%">
              <vs-button
                class="mr-2"
                type="border"
                @click="rejectPopup = false"
              >
                {{ $t("admin.label.Cancel") }}
              </vs-button>

              <vs-button @click="approvalRequest('reject')" color="warning">
                {{ $t("admin.label.Ok") }}
              </vs-button>
            </div>
          </div>
        </form>
      </vs-popup>
    </div>
    <delete-popup
      :deletePopup="deleteRulePopup"
      :title="$t('system.label.Rule')"
      @deletePressed="deleteGLAccount()"
      @cancelPressed="deleteRulePopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      deleteRulePopup: false,
      parsedCommandAsJson: {},
      approvePopup: false,
      rejectPopup: false,
    };
  },

  computed: {
    ...mapState({
      ApprovalData: (state) => state.admin.approvalsData,
    }),
  },
  methods: {
    async getDataById() {
      try {
        await this.$store.dispatch("admin/viewApprovalsAction", this.id);
      } catch (error) {
        //
      }
      this.parseCommandAsJson();
    },
    goToReview() {
      if (this.ApprovalData.entityName == "PLANSTATUS")
        this.$router.push({
          path: `/setup/plan-pricing/viewplan/${this.ApprovalData.resourceId}`,
        });
    },
    parseCommandAsJson() {
      if (this.ApprovalData && this.ApprovalData.commandAsJson) {
        this.parsedCommandAsJson = JSON.parse(this.ApprovalData.commandAsJson);
      }
    },
    async approvalRequest(request) {
      if (request == "approve") {
        this.approvePopup = false;
      } else this.rejectPopup = false;

      let payload = { id: this.id, permission: request };
      try {
        await this.$store.dispatch("admin/getPermission", payload);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.$router.push({ path: `/dashboard` });
    },
  },
  filters: {},
  async created() {
    this.id = this.$route.params.id;
    await this.getDataById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
